import { Countdown as CountdownBase } from '../../components/Countdown';
import { useLanguage } from '../../context/LanguageContext';
import { useSearchNavigate } from '../../hooks/useSearchNavigate';
import { ROUTES } from '../../routes';
import { Container } from './styles';
import { FloatingLogo } from '../../components/FloatingLogo';

export const Countdown = () => {
  const navigate = useSearchNavigate();
  const { language } = useLanguage();
  return (
    <Container>
      <FloatingLogo />
      <CountdownBase onFinish={() => navigate(ROUTES.Question)} />
      <h2>{language.great_youre_all_set}</h2>
      <h1>{language.get_ready}</h1>
    </Container>
  );
};
